import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/global.css";
import * as echarts from "echarts";
import store from './store/Storage'
import axios from 'axios';
import moment from 'moment';
import VueSessionStorage from 'vue-sessionstorage'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import '@/assets/fonts/font.css';

Vue.prototype.$moment = moment;

import * as lodash from 'lodash'
/* 全局lodash */
Vue.prototype.$baseLodash = lodash
/* 全局事件总线 */
Vue.prototype.$baseEventBus = new Vue()


const BASE_URL_DEV = "http://127.0.0.1:52000";
const BASE_URL_PRODUCTION = 'https://api-proxy.yanghaocheng.workers.dev'

Vue.prototype.$baseUrl = BASE_URL_PRODUCTION;

Vue.prototype.$userInfo = {
  $userName:'',
  $userLimit:''
}

Vue.prototype.$moment = moment
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI, { size: "mini" });
Vue.use(VueSessionStorage)
Vue.use(VueQuillEditor);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.prototype.$echarts = echarts;
